import { useEffect } from 'react';

export const useSecurityCode = deleteSecurityCode => useEffect(() => () => deleteSecurityCode(), []);
